<template>
  <IconLucideCircleQuestionMark />
</template>
